<template>
  <div class="flex">
    <div class="w-full text-center">
      Navigating to payment screen...
    </div>
  </div>
</template>

<script setup>

// send client to https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-be970494423b4d8aad27f85b28cddce0da9408511be54a788858758de082f19fef9a7a7f8bfb4aa68d735f2082568037?locale=EN_US

window.location.href = "https://connect.intuit.com/portal/app/CommerceNetwork/view/scs-v1-be970494423b4d8aad27f85b28cddce0da9408511be54a788858758de082f19fef9a7a7f8bfb4aa68d735f2082568037?locale=EN_US"

</script>

<style></style>